import { useContext, useState } from "react";
import { CadastroContext } from "../../../../contexts/CadastroContext";
import { Card, Button } from "react-bootstrap";
import AlertMessage from "../../../Alert";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import InputMask from "react-input-mask"; // Importa a biblioteca para máscaras
import "./style.css";

const AsoValidarInfoNome = () => {
	const { cadastro, handleCadastroChange } = useContext(CadastroContext);
	const [nome, setNome] = useState("");
	const [cpf, setCpf] = useState("");
	const [sexo, setSexo] = useState("");
	const [dataNascimento, setDataNascimento] = useState("");
	const [alert, setAlert] = useState({
		show: false,
		message: "",
		variant: "success",
	});
	const [disabled, setDisabled] = useState(true);
	const navigate = useNavigate();
	const { dbName } = useParams();
	const location = useLocation();

	const handleOnChange = () => {
		const cpfValid = validarCPF(cpf);
		setDisabled(!(nome && cpfValid && sexo && dataNascimento));
	};

	const handleContinuar = () => {
		cadastro.nome = nome;
		cadastro.cpf = cpf;
		cadastro.cpfValidado = true;
		cadastro.sexo = sexo;
		cadastro.data_nascimento = new Date(dataNascimento)
			.toISOString()
			.split("T")[0];
		handleCadastroChange(cadastro);

		return navigate(`/aso/registro/validar-identidade-aso/${dbName}`);
	};

	const handleCpfChange = (event: any) => {
		const value = event.target.value;
		setCpf(value);
		const cpfDigits = value.replace(/\D/g, "");
		const cpfValid = cpfDigits.length === 11 && validarCPF(value);
		setDisabled(!(nome && cpfValid && sexo && dataNascimento));
	};

	const validarCPF = (value: string): boolean => {
		// Remove caracteres não numéricos
		const cpfDigitos = value.replace(/\D/g, "");

		// Verifica se o CPF possui 11 dígitos numéricos
		if (cpfDigitos.length !== 11) {
			return false;
		}

		// Verifica se todos os dígitos são iguais (CPF inválido)
		if (/^(\d)\1{10}$/.test(cpfDigitos)) {
			return false;
		}

		// Calcula o primeiro dígito verificador
		let soma = 0;
		for (let i = 0; i < 9; i++) {
			soma += parseInt(cpfDigitos.charAt(i)) * (10 - i);
		}
		let resto = soma % 11;
		let digitoVerificador1 = resto < 2 ? 0 : 11 - resto;

		// Verifica o primeiro dígito verificador
		if (parseInt(cpfDigitos.charAt(9)) !== digitoVerificador1) {
			return false;
		}

		// Calcula o segundo dígito verificador
		soma = 0;
		for (let i = 0; i < 10; i++) {
			soma += parseInt(cpfDigitos.charAt(i)) * (11 - i);
		}
		resto = soma % 11;
		let digitoVerificador2 = resto < 2 ? 0 : 11 - resto;

		// Verifica o segundo dígito verificador
		if (parseInt(cpfDigitos.charAt(10)) !== digitoVerificador2) {
			return false;
		}

		// CPF válido
		return true;
	};

	const handleCpfBlur = () => {
		const digits = cpf.replace(/\D/g, "");
		// If incomplete or invalid on blur, show alert and disable
		if (digits.length < 11 || !validarCPF(cpf)) {
			setAlert({
				show: true,
				message: "Insira um CPF válido!",
				variant: "danger",
			});
			setDisabled(true);
		} else {
			setAlert({ ...alert, show: false });
			handleOnChange();
		}
	};

	return (
		<>
			<div className="aso-container-nome">
				<div className="aso-titulo-container-nome">
					<div className="aso-titulo-nome">Qual é o seu nome completo?</div>
				</div>
				<div className="aso-container-card-nome">
					<Card className="aso-card-nome">
						<div className="aso-card-content-container-nome">
							{/* Nome */}
							<div className="aso-card-content-nome">
								<label htmlFor="nome-input" className="label-container">
									<span className="aso-card-content-nome-label-span">Nome</span>
								</label>
								<div className="aso-card-content-container-nome-input">
									<input
										type="text"
										placeholder="Digite seu nome completo"
										onChange={(e) => {
											setNome(e.target.value);
											handleOnChange();
										}}
										className="aso-card-content-nome-input"
									/>
								</div>
							</div>

							{/* CPF */}
							<div className="aso-card-content-nome">
								<label htmlFor="cpf-input" className="label-container">
									<span className="aso-card-content-nome-label-span">CPF</span>
								</label>
								<div className="aso-card-content-container-nome-input">
									<InputMask
										mask="999.999.999-99"
										type="text"
										pattern="[0-9]*"
										id="cpf-input"
										title="Digite um CPF numérico"
										minLength={11}
										value={cpf}
										className="aso-card-content-nome-input"
										placeholder="Digite um CPF númerico"
										onChange={handleCpfChange}
										onBlur={handleCpfBlur}
									/>
								</div>
							</div>

							{/* Sexo */}
							<div className="aso-card-content-nome">
								<label htmlFor="sexo-select" className="label-container">
									<span className="aso-card-content-nome-label-span">Sexo</span>
								</label>
								<div className="aso-card-content-container-nome-input">
									<select
										id="sexo-select"
										className="aso-card-content-nome-input"
										onChange={(e) => {
											setSexo(e.target.value);
											handleOnChange();
										}}
									>
										<option value="">Selecione</option>
										<option value="M">Masculino</option>
										<option value="F">Feminino</option>
									</select>
								</div>
							</div>

							{/* Data de Nascimento */}
							<div className="aso-card-content-nome">
								<label
									htmlFor="data-nascimento-input"
									className="label-container"
								>
									<span className="aso-card-content-nome-label-span">
										Data de Nascimento
									</span>
								</label>
								<div className="aso-card-content-container-nome-input">
									<input
										type="date"
										onChange={(e) => {
											setDataNascimento(e.target.value);
											handleOnChange();
										}}
										className="aso-card-content-nome-input"
									/>
								</div>
							</div>
						</div>
					</Card>
					<div className="aso-button-nome-container">
						<Button
							variant="primary"
							className="aso-button-nome-content"
							onClick={handleContinuar}
							disabled={disabled}
						>
							Continuar
						</Button>
					</div>
				</div>
			</div>
			<AlertMessage
				show={alert.show}
				message={alert.message}
				variant={alert.variant}
				onClose={() => setAlert({ ...alert, show: false })}
			/>
		</>
	);
};

export default AsoValidarInfoNome;
